<template>
    <el-dialog :title="$t('高级身份认证')" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false">
        <div class="dialog-box">
            <div class="info-tip">
                <p class="txt-20">{{ $t('个人信息') }}</p>
                <p class="txt-12">
                    {{ $t('请提供真实的用户信息和证件号码，基本身份认证完成后相关信息便无法更改，并为后续认证提供信息基础。') }}
                </p>
            </div>

            <div class="dis-fle card-div">
                <div class="flex-1">
                    <label class="txt-14 txt-w7">{{ $t('证件正面') }}</label>
                    <uploadModel @success="frontUpload">
                        <div class="dis-fle ali-cen flex-col cur-poi">
                            <img v-if="form.frontPath" :src="form.frontPath" alt="" />
                            <img v-else src="@/assets/img-pc/card-front.png" alt="" />
                            <span>{{ $t('点击上传') }}</span>
                        </div>
                    </uploadModel>
                </div>
                <div class="flex-1">
                    <label class="txt-14 txt-w7">{{ $t('证件反面') }}</label>
                    <uploadModel @success="backUpload">
                        <div class="dis-fle ali-cen flex-col cur-poi">
                            <img v-if="form.backPath" :src="form.backPath" alt="" />
                            <img v-else src="@/assets/img-pc/card-back.png" alt="" />
                            <span>{{ $t('点击上传') }}</span>
                        </div>
                    </uploadModel>
                </div>
            </div>

            <div class="but" @click="submit">{{ $t('开始认证') }}</div>
        </div>
    </el-dialog>
</template>

<script>
import {
    post
} from '@/http/request'
import uploadModel from './upload.vue'
export default {
    components: {
        uploadModel
    },
    props: {
    },
    data() {
        return {
            dialogVisible: false,
            form: {},
        };
    },
    watch: {
    },
    mounted() {

    },
    beforeUnmount() { },
    methods: {
        open() {
            this.dialogVisible = true
            this.form = {
                front: '', //证件正面
                frontPath: '',
                back: '', //证件反面
                backPath: '',
            }
        },

        frontUpload(val) {
            this.form.front = val.url
            this.form.frontPath = val.fullurl
        },
        backUpload(val) {
            this.form.back = val.url
            this.form.backPath = val.fullurl
        },
        submit() {
            if (!this.form.front) {
                this.$notify.error(this.$t('请上传证件正面'))
                return
            }
            if (!this.form.back) {
                this.$notify.error(this.$t('请上传证件反面'))
                return
            }
            post(this.$apis.advancedReal, this.form).then(res => {
                if (res.code != 1) return
                this.$notify.success(res.msg)
                this.dialogVisible = false
                this.$emit('success', false)
            })
        }
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding-top: 10px;
}

::v-deep .el-dialog__title {
    color: #fff;
}

.dialog-box {
    padding: 10px 20px;

    .card-div {
        padding-top: 32px;

        img {
            width: 187px;
            height: 120px;
        }

        label {
            display: inline-block;
            margin-bottom: 20px;
        }

        span {
            color: #606266;
            font-size: 14px;
            margin-top: 16px;
        }
    }

    .info-tip {
        .txt-20 {
            margin-bottom: 10px;
        }
    }

    .but {
        width: 100%;
        height: 36px;
        line-height: 36px;
        background: #f0c163;
        opacity: 1;
        border-radius: 5px;
        font-size: 16px;
        font-weight: 400;
        color: #fff;
        margin-top: 32px;
        text-align: center;
        cursor: pointer;
    }
}
</style>